





























































import { Component, Prop, Vue } from "vue-property-decorator";
import { getTime } from "@/services/dateTime/getFullDate";
import { IOrder } from "@/@types/orders/new-order";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";

import InputSearch from "@/components/app/search/input-search.vue";

@Component({ components: { InputSearch } })
export default class OrderConstructoprHeader extends Vue {
  @Prop({ type: Array, default: () => [] }) orders!: Array<IOrder>;
  @Prop({ type: Object, default: null }) order!: IOrder;
  @Prop({ type: Object, default: null }) vroom!: IVirtualRooma;

  $refs!: { id: HTMLButtonElement };

  get date_create_order(): string {
    return getTime(this.order.date_create_order);
  }

  get new_orders_count(): number {
    let count = 0;
    this.orders.forEach((order) => {
      if (order.status == "new") count++;
    });
    return count;
  }

  copy(): void {
    document.designMode = "on";
    this.$nextTick(() => {
      const copyText = this.$refs.id.textContent;
      const textArea = document.createElement("textarea");
      textArea.textContent = copyText;
      document.body.append(textArea);
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
      this.$nextTick(() => (document.designMode = "off"));
    });
  }
}
